// extracted by mini-css-extract-plugin
export default {"menuList":"ProfileMenu_Mobile_menuList__XHlVy","menuItem":"ProfileMenu_Mobile_menuItem__1Qgyj","menuItem_span":"ProfileMenu_Mobile_menuItem_span__xGjC8"};